import { createPaginatedSlice } from "../../helpers/reduxHelper";

const dashboardTabMaterials = createPaginatedSlice('dashboardTabMaterials');

export const dashboardTabMaterialsActions = dashboardTabMaterials.actions
export const dashboardTabMaterialsSelector = state => state.dashboardTabMaterials;
export const dashboardTabMaterialsReducer = dashboardTabMaterials.reducer;
export default dashboardTabMaterialsReducer

export const dashboardTabMaterialsSelectors = dashboardTabMaterials.LF.selectors